import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ModalPopup from '@ui/components/VnModal';
import { useEffect, useState } from 'react';
import AddOrderLineForm from './AddOrderLineForm';
import { addOutline, cartOutline, closeCircleOutline, pencilOutline, saveOutline } from 'ionicons/icons';
import VnButton from '@ui/components/VnButton';
import '../../../workOrder/workOrderView/hoursAndMaterial/style.css';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useParams } from 'react-router-dom';
import { getAllOrderLineByOrderIdAsync, recievedAllOrderLinesAsync, updateBulkOrderLineAsync, updateOrderLineAsync } from '@application/features/orderlines/orderLineThunk';
import './style.css';
import VnNotificationModel from '@ui/components/VnNotificationModel';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import OrderLineViewTable from './OrderLineViewTable';
import { handleRolePermission } from '@infrastructure/helpers';
import { resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
import { VisserModule } from '@application/common/enums/visser-module';
import { updateModulePermissionsStatusAsync } from '@application/features/workorders/workorderThunk';
import OrderLineTable from './OrderLineTable';
const OrderLineTab = ({ disableRecord, formData, handleFieldChange, handleOrderStatusChange, isOrderLineTabBold }) => {
    const [orderLineId, setOrderLineId] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [orderLineList, setOrderLineList] = useState([]);
    const { orderLines, orderLinesWithRemovedWorkOrders } = useAppSelector((state) => state.orderLine);
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const [isToggledUpdate, setIstoggledUpdate] = useState(false);
    const [orderLineRowData, setOrderLineRowData] = useState();
    const [isShowRecieveToggleConfirmationPopup, setIsShowRecieveToggleConfirmationPopup] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editedData, setEditedData] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});
    async function handleToggle(orderLineData, receive) {
        var moduleLockStatus = await checkModulelock();
        if (orderLineData.id !== 0 && orderLineData.received == false && moduleLockStatus == false) {
            setIstoggledUpdate(true);
            const updatedOrderLineData = { ...orderLineData, received: receive };
            setOrderLineRowData(updatedOrderLineData);
        }
    }
    const { SelectedWorkorderCalculationsToOrderItemIdsList } = useAppSelector((state) => state.order);
    function onConfirmation() {
        if (orderLineRowData)
            dispatch(updateOrderLineAsync(orderLineRowData))
                .unwrap()
                .then((res) => {
                handleOrderStatusChange();
                if (id) {
                    dispatch(getAllOrderLineByOrderIdAsync(parseInt(id)))
                        .unwrap()
                        .then((res) => {
                        setOrderLineList(res);
                    });
                }
            });
        setIstoggledUpdate(false);
    }
    function onCancelatation() {
        setIstoggledUpdate(false);
    }
    useEffect(() => {
        if (id) {
            dispatch(getAllOrderLineByOrderIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setOrderLineList(res);
                if (isOrderLineTabBold && res.length > 0) {
                    isOrderLineTabBold(true);
                }
                else {
                    isOrderLineTabBold && isOrderLineTabBold(false);
                }
            });
        }
    }, [dispatch, id]);
    useEffect(() => {
        if (id && orderLinesWithRemovedWorkOrders && orderLinesWithRemovedWorkOrders?.length > 0) {
            dispatch(getAllOrderLineByOrderIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setOrderLineList(res);
            });
        }
    }, [orderLinesWithRemovedWorkOrders]);
    function oncloseClicked() {
        if (id) {
            dispatch(getAllOrderLineByOrderIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setOrderLineList(res);
                if (isOrderLineTabBold && res.length > 0) {
                    isOrderLineTabBold(true);
                }
                else {
                    isOrderLineTabBold && isOrderLineTabBold(false);
                }
            });
            setIsOpen(false);
        }
    }
    const onAddOrderLineClick = async () => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setIsOpen(true);
            setOrderLineId(0);
        }
    };
    const onCheckReceivedToggleClick = () => {
        if (id) {
            dispatch(recievedAllOrderLinesAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                if (id) {
                    dispatch(getAllOrderLineByOrderIdAsync(parseInt(id)))
                        .unwrap()
                        .then((res) => {
                        setOrderLineList(res);
                    });
                }
                setIsShowRecieveToggleConfirmationPopup(false);
                handleOrderStatusChange();
            })
                .catch((error) => { console.error('Bad request.'); setIsShowRecieveToggleConfirmationPopup(false); });
        }
    };
    async function onRowClick(rowId) {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setOrderLineId(rowId);
            setIsOpen(true);
        }
    }
    const onCancelRecieveTogglePopupClicked = () => {
        setIsShowRecieveToggleConfirmationPopup(false);
    };
    const handleOrderLineGridUpdate = () => {
        if (id) {
            dispatch(getAllOrderLineByOrderIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setOrderLineList(res);
                if (isOrderLineTabBold && res.length > 0) {
                    isOrderLineTabBold(true);
                }
                else {
                    isOrderLineTabBold && isOrderLineTabBold(false);
                }
            });
        }
    };
    const checkModulelock = async () => {
        if (parseInt(id)) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Bestellingen,
                recordId: parseInt(id)
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData)).unwrap();
                if (res.isModuleAlreadyLocked) {
                    dispatch(setModuleLock());
                    return true;
                }
                dispatch(unsetModuleLock());
                return false;
            }
            catch (error) {
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    useEffect(() => {
        appendDataintoEdit();
    }, [orderLineList]);
    async function onEdit() {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setIsEditing(true);
        }
    }
    function onSave() {
        if (editedData) {
            let hasErrors = false;
            let newErrors = {};
            const lastRow = editedData[editedData.length - 1];
            const isRowEmpty = (row) => {
                return Object.entries(row)
                    .filter(([key]) => key !== 'id' && key !== 'orderId')
                    .every(([_, value]) => value === null || value === undefined || value === '' || value === 0 || value === false);
            };
            editedData.forEach((item, index) => {
                if (index === editedData.length - 1 && isRowEmpty(lastRow)) {
                    return;
                }
                if (!formData.isWorkOrderLinked && !item.workOrderId) {
                    newErrors[item.id] = { ...newErrors[item.id], workOrderId: true };
                    hasErrors = true;
                }
                if (!item.name || item.name.trim() === '') {
                    newErrors[item.id] = { ...newErrors[item.id], name: true };
                    hasErrors = true;
                }
            });
            if (hasErrors) {
                setValidationErrors(newErrors);
                return;
            }
            setValidationErrors({});
            const updatedData = editedData.map((item) => {
                return {
                    ...item,
                    quantity: item.quantity === '' ? 0 : item.quantity,
                    unitPrice: item.unitPrice === '' ? 0 : item.unitPrice,
                    discount: item.discount === '' ? 0 : item.discount,
                    netPrice: item.netPrice === '' ? 0 : item.netPrice,
                    sellingPrice: item.sellingPrice === '' ? 0 : item.sellingPrice,
                };
            });
            if (isRowEmpty(lastRow)) {
                updatedData.pop();
            }
            dispatch(updateBulkOrderLineAsync(updatedData))
                .unwrap()
                .then(() => {
                setIsEditing(false);
                dispatch(getAllOrderLineByOrderIdAsync(parseInt(id)))
                    .unwrap()
                    .then((res) => {
                    setOrderLineList(res);
                });
            })
                .catch((error) => {
                if (isRowEmpty(lastRow)) {
                    setEditedData([...updatedData, lastRow]);
                }
            });
        }
    }
    const clearValidationErrors = (id, field) => {
        setValidationErrors((prev) => ({
            ...prev,
            [id]: {
                ...prev[id],
                [field]: false
            },
        }));
    };
    function onCancel() {
        setIsEditing(false);
        orderLines && setOrderLineList(orderLines);
    }
    function appendDataintoEdit() {
        if (orderLineList) {
            setEditedData((data) => {
                const updatedData = orderLineList.map((orderline) => ({ ...orderline }));
                return updatedData;
            });
        }
    }
    function onEditData(data) {
        setEditedData(data);
        setOrderLineList(data);
    }
    //------------checking if localstorage has calculations or not----------------
    const hasCalculationDataInLocalStorage = () => {
        const params = new URLSearchParams(window.location.search);
        const dataKey = params.get('dataKey');
        if (!dataKey)
            return false;
        const dataString = localStorage.getItem(dataKey);
        if (!dataString)
            return false;
        try {
            const data = JSON.parse(dataString);
            return Array.isArray(data.selectedCalculations) && data.selectedCalculations.length > 0;
        }
        catch {
            return false;
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: 'vn-Material-Add-buttons', children: [isEditing && (_jsxs(_Fragment, { children: [_jsx(VnButton, { icon: closeCircleOutline, customClassName: 'vn-action-button vn-inline-editing-action-button', mode: 'danger', size: 'sm', isDisabled: id && !disableRecord ? false : true, customIconClassName: 'vn-action-button-icon vn-inline-editing-action-button-icon', onClick: () => {
                                    onCancel();
                                } }), _jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button vn-inline-editing-action-button mr-14', mode: 'primary', size: 'sm', onClick: () => {
                                    onSave();
                                }, type: 'submit', customIconClassName: 'vn-action-button-icon vn-inline-editing-action-button-icon', isDisabled: !disableRecord ? false : true })] })), !isEditing && id && (_jsx(VnButton, { icon: pencilOutline, customClassName: 'vn-action-button-cancel vn-inline-editing-action-button mr-14', mode: 'secondary', size: 'sm', customIconClassName: 'vn-action-button-cancel-icon vn-inline-editing-action-button-icon', onClick: () => {
                            onEdit();
                        }, isDisabled: handleRolePermission(Permission.BESTELLINGEN, PermissionType.Update) && !disableRecord ? false : true })), id && (_jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button mt-1 mb-3', icon: cartOutline, onClick: async () => {
                            var moduleLockStatus = await checkModulelock();
                            if (moduleLockStatus == false) {
                                setIsShowRecieveToggleConfirmationPopup(true);
                            }
                        }, style: { marginRight: '5px' }, isDisabled: !handleRolePermission(Permission.BESTELLINGEN, PermissionType.Update) || disableRecord, children: "Alles Ontvangen" })), id && _jsx("span", { className: 'vn-vertical-line' }), id && (_jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button mt-1 mb-3', icon: addOutline, onClick: onAddOrderLineClick, style: { marginRight: '5px' }, isDisabled: isEditing || !(handleRolePermission(Permission.BESTELLINGEN, PermissionType.Create) || disableRecord), children: "Regel toevoegen" }))] }), hasCalculationDataInLocalStorage() ? (_jsx(OrderLineViewTable, { formData: formData, handleFieldChange: handleFieldChange, SelectedWorkorderCalculationsToOrderItemIdsList: SelectedWorkorderCalculationsToOrderItemIdsList, isOrderLineTabBold: isOrderLineTabBold })) : (_jsx(OrderLineTable, { isEditing: isEditing, editedData: editedData, editData: onEditData, onRowClick: onRowClick, disableRecord: disableRecord, formData: formData, orderLineData: orderLineList, handleToggle: handleToggle, validationErrors: validationErrors, clearValidationErrors: clearValidationErrors })), _jsx(VnNotificationModel, { message: 'Wilt u de ontvangststatus wijzigen?', onCancel: () => onCancelatation(), onConfirm: () => onConfirmation(), onOpen: isToggledUpdate, onCancelShow: true }), _jsx(ModalPopup, { title: 'Toevoegen regels', content: _jsx(AddOrderLineForm, { onClose: () => oncloseClicked(), orderLineId: orderLineId, disableRecord: disableRecord, onOrderLineGridUpdate: handleOrderLineGridUpdate, handleOrderStatusChange: handleOrderStatusChange, formData: formData }), onOpen: isOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' }), _jsx(VnNotificationModel, { message: 'Weet u zeker dat u de status van alle orderregels wilt wijzigen in Ontvangen?', onCancel: () => onCancelRecieveTogglePopupClicked(), onConfirm: () => onCheckReceivedToggleClick(), onOpen: isShowRecieveToggleConfirmationPopup, onCancelShow: true })] }));
};
export default OrderLineTab;
